import { AutocompleteResult, AutocompleteSectionId, SearchAutocompleteSection } from "../types";
import { ListSection } from "./ListSection";

interface SearchResultsContentProps {
  visibleSections: SearchAutocompleteSection[];
  searchResults: Map<AutocompleteSectionId, AutocompleteResult[]>;
  highlightedIndex: number;
  isMouseActive: boolean;
  handleSelect: (result: AutocompleteResult, section: SearchAutocompleteSection) => void;
  highlightedRef: React.RefObject<HTMLButtonElement>;
}

export function SearchResultsContent({
  visibleSections,
  searchResults,
  highlightedIndex,
  isMouseActive,
  handleSelect,
  highlightedRef,
}: SearchResultsContentProps) {
  return (
    <ol className="flex flex-col gap-2 m-0 list-none divide-y appearance-none divide-border-base-divider">
      {visibleSections.map((section, sectionIndex) => {
        const results = searchResults.get(section.id) || [];
        if (!results.length) return null;

        const previousSectionsItemCount = visibleSections
          .slice(0, sectionIndex)
          .reduce((count, s) => count + (searchResults.get(s.id)?.length || 0), 0);

        return (
          <ListSection
            key={section.id}
            title={section.title}
            items={results.map((result) => ({ result, section }))}
            highlightedIndex={highlightedIndex}
            isMouseActive={isMouseActive}
            onSelect={({ result, section }) => handleSelect(result, section)}
            highlightedRef={highlightedRef}
            sectionIndex={sectionIndex}
            previousSectionsItemCount={previousSectionsItemCount}
          />
        );
      })}
    </ol>
  );
}
